/* eslint-disable */
// @ts-ignore
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import type { AliaChatQuestion } from "~/foundation/SitecoreContent/generated-types";
import type { AliaChatMessage } from "~/foundation/SitecoreContent/generated-types";
import type { AliaChatFeedback } from "~/foundation/SitecoreContent/generated-types";
import type { AliaChatMessages } from "~/foundation/SitecoreContent/generated-types";

export const aliaChatServiceMeta: Meta<typeof aliaChatService> = {
	chatQuestion: ["POST", "/api/v1/alia/chat"],
	feedbackMessage: ["POST", "/api/v1/alia/feedback"],
	getMessages: ["GET", "/api/v1/alia/messages/:chatlogId"],
};

// Foundation.SitecoreContent.WebApi.Alia.AliaChatApiController
export const aliaChatService = {
	async chatQuestion(body: AliaChatQuestion, headers?: Record<string, any>) {
		return await http.fetch<AliaChatMessage, AliaChatQuestion>(aliaChatServiceMeta.chatQuestion, { body, headers });
	},
	async feedbackMessage(body: AliaChatFeedback, headers?: Record<string, any>) {
		return await http.fetch<undefined, AliaChatFeedback>(aliaChatServiceMeta.feedbackMessage, { body, headers });
	},
	async getMessages(chatlogId: string, headers?: Record<string, any>) {
		return await http.fetch<AliaChatMessages, undefined>(aliaChatServiceMeta.getMessages, { params: { chatlogId }, headers });
	},
};
